import React from "react";
import PropTypes from "prop-types";

const COOKIE_POLICY_URL = "https://www.iubenda.com/privacy-policy/11864639/cookie-policy";

// Shown in place of a YouTube video until the viewer allows YouTube's cookies.
const YouTubeConsentPrompt = ({ onAccept }) => (
  <div className="youtube-consent">
    <p className="youtube-consent-text">
      Videos are hosted on YouTube, which sets cookies when you watch.{" "}
      <a href={COOKIE_POLICY_URL} rel="noopener noreferrer" target="_blank">
        Cookie policy
      </a>
    </p>
    <button className="btn btn-success joystix" onClick={onAccept} type="button">
      Allow YouTube cookies and watch
    </button>
  </div>
);

YouTubeConsentPrompt.propTypes = {
  onAccept: PropTypes.func.isRequired,
};

export default YouTubeConsentPrompt;
